import currentZone from "@/services/currentZone";
import currentCampaign from "@/services/currentCampaign";
import currentStandDesign from "@/services/currentStandDesign";
import currentBrand from "@/services/currentBrand";
import Globals from "@/components/globals";
import cacheService from "@/services/cache";

export const currentUser = {
    namespaced: true,
    state: {
        currentCampaign: { id: cacheService.getCurrentCampaignId() || 0 },
        currentZone: { id: cacheService.getCurrentZoneId() },
        currentBrand: {},
        currentStandDesign: { id: cacheService.getCurrentStandId() },
        currentProfiles: []
    },

    getters: {
        currentUser(state) {
            let user = cacheService.getRem3rchUser();
            return {
                user: (user && user.user) || {},
                brandId: cacheService.getCurrentBrandId(),
                campaignId: state.currentCampaign.id || cacheService.getCurrentCampaignId(),
                standDesignId: state.currentStandDesign.id || parseInt(cacheService.getCurrentStandId()),
                zoneId: state.currentZone.id || cacheService.getCurrentZoneId()
            };
        },
        currentBrand() {
            const userJson = cacheService.getRem3rchUser();
            const brandId = parseInt(cacheService.getCurrentBrandId(), 10);
            const user = userJson && userJson.user;
            return user && user.brands.find(brand => parseInt(brand.id, 10) === brandId);
        },
        currentProfiles() {
            const userJson = cacheService.getRem3rchUser();
            const user = userJson && userJson.user;
            return user && user.profiles;
        }
    },

    mutations: {
        SET_CURRENT_CAMPAIGN: (state, campaign) => {
            cacheService.set("currentCampaignId", campaign.id);
            state.currentCampaign = campaign;
        },
        SET_CURRENT_ZONE: (state, zone) => {
            cacheService.set("currentZoneId", zone.id);
            state.currentZone = zone;
        },
        SET_CURRENT_BRAND: (state, brand) => {
            cacheService.set("currentBrandId", brand.id);
            const brandColors = cacheService.getBrandColors();
            state.currentBrand = { ...brand, brandColors };
        },
        SET_CURRENT_STAND_DESIGN: (state, standDesign) => {
            cacheService.set("currentStandId", standDesign.id);
            state.currentStandDesign = standDesign;
        }
    },
    actions: {
        async populateInfo(context) {
            const brand = await currentBrand.get();
            const campaign = await currentCampaign.get(parseInt(cacheService.getCurrentCampaignId()));
            context.commit("SET_CURRENT_BRAND", brand);
            context.commit("SET_CURRENT_ZONE", currentZone.get());
            context.commit("SET_CURRENT_CAMPAIGN", campaign);
        },
        updateCurrentBrand({ commit }, brand) {
            commit("SET_CURRENT_BRAND", brand);
        },
        setCurrentZoneId({ commit }, zoneId) {
            cacheService.set("currentZoneId", zoneId);
            commit("SET_CURRENT_ZONE", currentZone.get());
        },
        async setCurrentCampaignId({ commit }, campaignId) {
            cacheService.set("currentCampaignId", campaignId);
            const campaign = await currentCampaign.get(campaignId);
            commit("SET_CURRENT_CAMPAIGN", campaign);
        },
        async setCurrentStandDesignId({ commit }, standDesignId) {
            cacheService.set("currentStandId", standDesignId);
            const standDesign = await currentStandDesign.get(standDesignId);
            commit("SET_CURRENT_STAND_DESIGN", standDesign);
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/currrentUser/currentUser.js